import Highcharts from "highcharts";

Highcharts.setOptions({
    lang: {
        thousandsSep: ",",
    },
    accessibility: {
        enabled: false,
    },
});

export default Highcharts;
